// src/pages/qc/CustomerSampleModal.jsx
import { useState } from "react";
import { todayDubai } from "../../utils/dateUtils";

const EMPTY = {
  date:         todayDubai(),
  customerName: "",
  sampleRef:    "",
  viscosity:    "",
  viscUnit:     "B4_CUP",
  viscTempC:    "",
  solidPct:     "",
  ph:           "",
  remarks:      "",
};

function num(v) { return v === "" ? null : parseFloat(v); }

function Row({ label, children }) {
  return (
    <div className="form-row">
      <span className="form-label">{label}</span>
      <div style={{ display:"flex", gap:6, alignItems:"center", flex:1 }}>{children}</div>
    </div>
  );
}

export function CustomerSampleModal({ onSave, onCancel, initialRef = "" }) {
  const [form,   setForm]   = useState({ ...EMPTY, sampleRef: initialRef });
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState(null);

  function set(f, v) { setForm(p => ({ ...p, [f]: v })); }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.sampleRef.trim()) { setError("Sample reference is required."); return; }
    if (!form.solidPct && !form.viscosity) {
      setError("Enter at least one measured value (Solids or Viscosity).");
      return;
    }
    setSaving(true); setError(null);
    try {
      await onSave({
        date:         form.date,
        customerName: null,
        sampleRef:    form.sampleRef.trim(),
        viscosity:    num(form.viscosity),
        viscUnit:     form.viscosity ? form.viscUnit : null,
        viscTempC:    num(form.viscTempC),
        solidPct:     num(form.solidPct),
        ph:           num(form.ph),
        remarks:      form.remarks.trim() || null,
      });
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  }

  return (
    <div className="modal wide">
      <div className="modal-header">
        <h3 className="modal-title">Log Customer Sample</h3>
        <button className="btn" onClick={onCancel}>✕</button>
      </div>

      <form onSubmit={handleSubmit}>
        <Row label="Date">
          <input type="date" className="form-input" value={form.date}
            onChange={e => set("date", e.target.value)} required style={{ width:160 }} />
        </Row>

        <Row label="Sample Ref *">
          <input className="form-input" placeholder="e.g. S-2025-001 or product name"
            value={form.sampleRef} onChange={e => set("sampleRef", e.target.value)}
            style={{ flex:1 }} />
        </Row>

        <div className="form-sep" />

        <Row label="Solid Content (%)">
          <input type="number" className="form-input" step="any" placeholder="e.g. 52.5"
            value={form.solidPct} onChange={e => set("solidPct", e.target.value)}
            style={{ width:120 }} />
        </Row>

        <Row label="Viscosity">
          <input type="number" className="form-input" step="any" placeholder="value"
            value={form.viscosity} onChange={e => set("viscosity", e.target.value)}
            style={{ width:110 }} />
          <select className="form-select" value={form.viscUnit}
            onChange={e => set("viscUnit", e.target.value)} style={{ width:150 }}>
            <option value="B4_CUP">B4 Cup (s)</option>
            <option value="BROOKFIELD">Brookfield (cP)</option>
          </select>
          <span style={{ fontSize:12, color:"#888" }}>@</span>
          <input type="number" className="form-input" step="any" placeholder="°C"
            value={form.viscTempC} onChange={e => set("viscTempC", e.target.value)}
            style={{ width:70 }} />
          <span style={{ fontSize:12, color:"#888" }}>°C</span>
        </Row>

        <Row label="pH">
          <input type="number" className="form-input" step="any" placeholder="e.g. 7.2"
            value={form.ph} onChange={e => set("ph", e.target.value)}
            style={{ width:120 }} />
        </Row>

        <div className="form-sep" />

        <Row label="Remarks">
          <textarea className="form-input" rows={2} placeholder="Optional notes…"
            value={form.remarks} onChange={e => set("remarks", e.target.value)}
            style={{ flex:1, resize:"vertical" }} />
        </Row>

        {error && <div className="alert-warn" style={{ marginTop:8 }}>{error}</div>}

        <div style={{ display:"flex", gap:8, justifyContent:"flex-end", marginTop:16 }}>
          <button type="button" className="btn" onClick={onCancel} disabled={saving}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? "Saving…" : "Save & Match"}
          </button>
        </div>
      </form>
    </div>
  );
}
